

import { cn } from '@/lib/utils';

interface GoogleAuthProps {
  onAuth: () => void;
  isDarkMode: boolean;
  isLoading?: boolean;
  className?: string;
}

export const GoogleAuth = ({ onAuth, isDarkMode, isLoading = false, className }: GoogleAuthProps) => {
  return (
    <button
      onClick={onAuth}
      disabled={isLoading}
      className={cn(
        'gsi-material-button',
        'w-[200px] min-w-[min-content] h-10',
        'flex items-center justify-center',
        'rounded-[20px] border border-[#D9D9D9]',
        'bg-white text-[#1f1f1f]',
        'px-3 py-0',
        'text-sm font-medium font-["Roboto",sans-serif]',
        'transition-all duration-218 ease-in-out',
        'hover:shadow-[0_1px_2px_0_rgba(60,64,67,0.1),0_1px_3px_1px_rgba(60,64,67,0.1)]',
        'disabled:bg-[#ffffff61] disabled:border-[#1f1f1f1f] disabled:cursor-default',
        'relative overflow-hidden',
        'select-none outline-none',
        className,
        isDarkMode && 'bg-white text-black border-[#D9D9D9] hover:bg-white/80',
      )}
    >
      <div className="gsi-material-button-state absolute inset-0 opacity-0 transition-opacity duration-218 ease-in-out group-hover:opacity-[0.08] group-hover:bg-[#303030]" />
      <div className="gsi-material-button-content-wrapper flex items-center justify-between w-full h-full">
        <div className="gsi-material-button-icon w-5 h-5 mr-3 flex-shrink-0">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="block w-full h-full">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
            <path fill="none" d="M0 0h48v48H0z"></path>
          </svg>
        </div>
        <span className="gsi-material-button-contents flex-grow text-left overflow-hidden text-ellipsis whitespace-nowrap">
          {isLoading ? 'Signing in...' : 'Continue with Google'}
        </span>
      </div>
    </button>
  );
};
